import { actionForState } from '../../../utils/helpers';
import { FORM_ANSWERS_LIST, FORMS_PUBLISHED_LIST, PUBLISHED_FORM, PORTAL_FORMS_GET_SCHEMA,
  CLEAR_LOADING_ACTIONS, FORM_ANSWER_DETAILS, CREATE_FORM_ANSWER, APPROVE_FORM_ANSWER,
  REJECT_FORM_APPROVAL, PORTAL_APPROVAL_SEND_BACK, SAVE_FORMS_VIEW_TAB, CLEAR_FORM_DETAILS, UPDATE_FORM_ANSWER,
  GET_PORTAL_USERS_LIST_FOR_PORTAL_FIELD, PORTAL_FORMS_GET_APPROVALS_LIST, GET_SELECTED_USERS, DELETE_FORM_ANSWER,
  FETCH_DATA_SOURCE_FORM_DETAILS, PORTAL_APPROVAL_SEND_BACK_WITH_DATA } from './types';

const apiPayload = {
  success: false,
  loading: false,
  error: false
};

const INITIAL_STATE = {
  formAnswerListAction: {
    success: false,
    loading: false,
    error: false
  },
  formsAnswerList: [],
  portal_users_list: [],
  publishedFormsList: [],
  publishedFormData: {},
  getPublishedFormAction: apiPayload,
  getFormsSchema: {},
  getFormsSchemaAction: apiPayload,
  formAnswerDetails: {},
  formAnswerDetailAction: apiPayload,
  createFormAnswerAction: apiPayload,
  formApprovalAction: apiPayload,
  formRejectionAction: apiPayload,
  formSendbackAction: apiPayload,
  updateFormAnswerAction: apiPayload,
  portal_users_list_actioin: apiPayload,
  myPendingApprovalsAction: apiPayload,
  myPendingApprovalsList: [],
  myFormsViewTab: 'forms',
  fetchLinkedAnswerAction: apiPayload,
  linkedFormAnswerDetails: []
};

// eslint-disable-next-line func-names
export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case FORM_ANSWERS_LIST.pending:
      return {
        ...state,
        formAnswerListAction: actionForState(state.action, 'pending')
      };
    case FORM_ANSWERS_LIST.success: {
      return {
        ...state,
        formsAnswerList: action.payload,
        formAnswerListAction: actionForState(state.action, 'success')
      };
    }
    case FORM_ANSWERS_LIST.error:
      return {
        ...state,
        formAnswerListAction: actionForState(state.action, 'error')
      };

    case FORMS_PUBLISHED_LIST.pending:
      return {
        ...state,
        formAnswerListAction: actionForState(state.action, 'pending')
      };
    case FORMS_PUBLISHED_LIST.success: {
      return {
        ...state,
        publishedFormsList: action.payload,
        formAnswerListAction: actionForState(state.action, 'success')
      };
    }
    case FORMS_PUBLISHED_LIST.error:
      return {
        ...state,
        formAnswerListAction: actionForState(state.action, 'error')
      };

    case PUBLISHED_FORM.pending:
      return {
        ...state,
        getPublishedFormAction: actionForState(state.action, 'pending')
      };
    case PUBLISHED_FORM.success: {
      return {
        ...state,
        publishedFormData: action.payload,
        getPublishedFormAction: actionForState(state.action, 'success')
      };
    }
    case PUBLISHED_FORM.error:
      return {
        ...state,
        getPublishedFormAction: actionForState(state.action, 'error')
      };

    case PORTAL_FORMS_GET_SCHEMA.pending:
      return {
        ...state,
        getFormsSchemaAction: actionForState(state.action, 'pending')
      };
    case PORTAL_FORMS_GET_SCHEMA.success: {
      return {
        ...state,
        getFormsSchema: action.payload,
        getFormsSchemaAction: actionForState(state.action, 'success')
      };
    }
    case PORTAL_FORMS_GET_SCHEMA.error:
      return {
        ...state,
        getFormsSchemaAction: actionForState(state.action, 'error')
      };

    case GET_PORTAL_USERS_LIST_FOR_PORTAL_FIELD.pending:
      return {
        ...state,
        portal_users_list_actioin: actionForState(state.action, 'pending')
      };
    case GET_PORTAL_USERS_LIST_FOR_PORTAL_FIELD.success: {
      return {
        ...state,
        portal_users_list: action.payload?.portal_users,
        portal_users_list_actioin: actionForState(state.action, 'success')
      };
    }
    case GET_PORTAL_USERS_LIST_FOR_PORTAL_FIELD.error:
      return {
        ...state,
        portal_users_list_actioin: actionForState(state.action, 'error')
      };

    case FORM_ANSWER_DETAILS.pending:
      return {
        ...state,
        formAnswerDetailAction: actionForState(state.action, 'pending')
      };
    case FORM_ANSWER_DETAILS.success: {
      return {
        ...state,
        formAnswerDetails: action.payload,
        formAnswerDetailAction: actionForState(state.action, 'success')
      };
    }
    case FORM_ANSWER_DETAILS.error:
      return {
        ...state,
        formAnswerDetailAction: actionForState(state.action, 'error')
      };

    case FETCH_DATA_SOURCE_FORM_DETAILS.pending:
      return {
        ...state,
        fetchLinkedAnswerAction: actionForState(state.action, 'pending')
      };
    case FETCH_DATA_SOURCE_FORM_DETAILS.success: {
      return {
        ...state,
        linkedFormAnswerDetails: action.payload || [],
        fetchLinkedAnswerAction: actionForState(state.action, 'success')
      };
    }
    case FETCH_DATA_SOURCE_FORM_DETAILS.error:
      return {
        ...state,
        fetchLinkedAnswerAction: actionForState(state.action, 'error')
      };

    case PORTAL_FORMS_GET_APPROVALS_LIST.pending:
      return {
        ...state,
        myPendingApprovalsAction: actionForState(state.action, 'pending')
      };
    case PORTAL_FORMS_GET_APPROVALS_LIST.success: {
      return {
        ...state,
        myPendingApprovalsList: action.payload,
        myPendingApprovalsAction: actionForState(state.action, 'success')
      };
    }
    case PORTAL_FORMS_GET_APPROVALS_LIST.error:
      return {
        ...state,
        myPendingApprovalsAction: actionForState(state.action, 'error')
      };

    case CREATE_FORM_ANSWER.pending:
      return {
        ...state,
        createFormAnswerAction: actionForState(state.action, 'pending')
      };
    case CREATE_FORM_ANSWER.success: {
      return {
        ...state,
        formAnswerDetails: action.payload,
        createFormAnswerAction: actionForState(state.action, 'success')
      };
    }
    case CREATE_FORM_ANSWER.error:
      return {
        ...state,
        createFormAnswerAction: actionForState(state.action, 'error')
      };


    case CLEAR_LOADING_ACTIONS:
      return {
        ...state,
        ...action.payload
      };

    case APPROVE_FORM_ANSWER.pending:
      return {
        ...state,
        formApprovalAction: actionForState(state.action, 'pending')
      };
    case APPROVE_FORM_ANSWER.success: {
      return {
        ...state,
        formApprovalAction: actionForState(state.action, 'success')
      };
    }
    case APPROVE_FORM_ANSWER.error:
      return {
        ...state,
        formApprovalAction: actionForState(state.action, 'error')
      };

    case REJECT_FORM_APPROVAL.pending:
      return {
        ...state,
        formRejectionAction: actionForState(state.action, 'pending')
      };
    case REJECT_FORM_APPROVAL.success: {
      return {
        ...state,
        formRejectionAction: actionForState(state.action, 'success')
      };
    }
    case REJECT_FORM_APPROVAL.error:
      return {
        ...state,
        formRejectionAction: actionForState(state.action, 'error')
      };

    case PORTAL_APPROVAL_SEND_BACK.pending:
      return {
        ...state,
        formSendbackAction: actionForState(state.action, 'pending')
      };
    case PORTAL_APPROVAL_SEND_BACK.success: {
      return {
        ...state,
        formSendbackAction: actionForState(state.action, 'success')
      };
    }
    case PORTAL_APPROVAL_SEND_BACK.error:
      return {
        ...state,
        formSendbackAction: actionForState(state.action, 'error')
      };
      case PORTAL_APPROVAL_SEND_BACK_WITH_DATA.pending:
      return {
        ...state,
        formSendbackAction: actionForState(state.action, 'pending')
      };
    case PORTAL_APPROVAL_SEND_BACK_WITH_DATA.success: {
      return {
        ...state,
        formSendbackAction: actionForState(state.action, 'success')
      };
    }
    case PORTAL_APPROVAL_SEND_BACK_WITH_DATA.error:
      return {
        ...state,
        formSendbackAction: actionForState(state.action, 'error')
      };
    case SAVE_FORMS_VIEW_TAB:
      return {
        ...state,
        myFormsViewTab: action.payload
      };

    case CLEAR_FORM_DETAILS:
      return {
        formAnswerDetails: {}
      };

    case UPDATE_FORM_ANSWER.pending:
      return {
        ...state,
        updateFormAnswerAction: actionForState(state.action, 'pending')
      };
    case UPDATE_FORM_ANSWER.success: {
      return {
        ...state,
        updateFormAnswerAction: actionForState(state.action, 'success')
      };
    }
    case UPDATE_FORM_ANSWER.error:
      return {
        ...state,
        updateFormAnswerAction: actionForState(state.action, 'error')
      };
    case GET_SELECTED_USERS.pending:
      return {
        ...state,
        action: actionForState(state.action, 'pending')
      };
    case GET_SELECTED_USERS.success: {
      return {
        ...state,
        selected_users: action.payload,
        fetchFormAction: actionForState(state.action, 'success')
      };
    }
    case GET_SELECTED_USERS.error:
      return {
        ...state,
        action: actionForState(state.action, 'error')
      };
       case DELETE_FORM_ANSWER.pending:
      return {
        ...state,
        deleteAnswerAction: actionForState(state.action, 'pending')
      };
    case DELETE_FORM_ANSWER.success: {
      return {
        ...state,
        deleteAnswerAction: actionForState(state.action, 'success')
      };
    }
    case DELETE_FORM_ANSWER.error:
      return {
        ...state,
        deleteAnswerAction: actionForState(state.action, 'error')
      };

    default:
      return state;
  }
}
